import React, {CSSProperties} from "react";
import {observer} from "mobx-react";
import {IBookingViewModel} from "../../../services/booking/models/booking-view-model.interface";
import {TicketFeesComponent} from "./ticket-fees.component";
import {useServices} from "../../../hooks/use-services.hook";

export const BookingLevelFeesTotalComponent: React.FC<{ booking: IBookingViewModel;}> = observer((props)=> {
    const services = useServices();
    const theme = services.theme.currentTheme;
    const styles: CSSProperties = {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        fontSize: theme.fontSize.h2,
        fontWeight: theme.fontWeight.bold,
        paddingLeft: theme.spacing.cardDefaultPadding,
        paddingRight: theme.spacing.cardDefaultPadding,
        pageBreakInside: "avoid",
        breakInside: "avoid",
    }


    return (
        <div style={styles}>
            <span>
                {services.language.translate('Other services total')}
            </span>
            <span>
                {props.booking.shoppingCart.allBookingLevelFeesTotal.toString()}
            </span>
        </div>
    )
});

export const TicketBookingLevelFeesComponent: React.FC<{ booking: IBookingViewModel;}> = observer((props)=> {
    const services = useServices();

    const fees = props.booking.shoppingCart.allBookingLevelFees;
    if(fees.length === 0) {
        return null;
    }

    const theme = services.theme.currentTheme;

    const styles: CSSProperties = {
        display: 'flex',
        flexDirection: "column",
        gap: theme.spacing.flexGap8,
        width: '100%',

    }

    const titleStyle: CSSProperties = {
        fontSize: theme.fontSize.h2,
        fontWeight: theme.fontWeight.bold,
        paddingLeft: theme.spacing.cardDefaultPadding,
    }

    return (
        <div style={styles}>
            <div style={titleStyle}>{services.language.translate('Other services')}</div>
            <TicketFeesComponent fees={fees}/>
            <BookingLevelFeesTotalComponent booking={props.booking}/>
        </div>
    )
})